import React from 'react';
import { faDog, faCat } from '@fortawesome/free-solid-svg-icons';
import ProductCta from '../../../components/ProductCta/ProductCta';
import { benefits, contactData, serviceHighlights } from './data';

const Ogolne = () => {
  return (
    <div className="pethelp-page">
      <section className="pethelp-hero">
        <div className="pethelp-hero-grid">
          <div>
            <div className="pethelp-kicker">Opieka weterynaryjna premium</div>
            <img
              src="/tvp/pethelp-image1.png"
              alt="Pethelp"
              className="pethelp-logo"
            />
            <h1 className="pethelp-title">
              Profilaktyka i leczenie pupila w jednej, wygodnej formule.
            </h1>
            <p className="pethelp-lead">
              Pethelp to pakiety weterynaryjne dla opiekunów zwierząt, którzy
              chcą planować profilaktykę, ograniczyć koszty leczenia i mieć
              dostęp do nowoczesnego panelu klienta z historią zdrowia pupila.
            </p>
            <div className="pethelp-badges">
              <div className="pethelp-badge">Ponad 869 placówek</div>
              <div className="pethelp-badge">Pies i kot w jednej ofercie</div>
              <div className="pethelp-badge">
                Panel klienta i konsultacje online
              </div>
            </div>
            <div className="pethelp-actions">
              <ProductCta to="/pethelp/pakiet-dla-psa/" icon={faDog}>
                Zobacz pakiet dla psa
              </ProductCta>
              <ProductCta to="/pethelp/pakiet-dla-kota/" icon={faCat}>
                Zobacz pakiet dla kota
              </ProductCta>
            </div>
          </div>

          <div className="pethelp-card">
            <div className="pethelp-eyebrow">Kontakt</div>
            <h3 className="pethelp-title-sm">Program Pethelp</h3>
            <p className="pethelp-muted">
              Pakiet łączy wizyty, badania, szczepienia i usługi dodatkowe z
              cyfrową obsługą zdrowia zwierzaka.
            </p>
            <div className="pethelp-stat">
              <strong>{contactData.phone}</strong>
              <span>Infolinia i wsparcie klienta</span>
            </div>
            <div className="pethelp-stat mt-3">
              <strong>{contactData.email}</strong>
              <span>Kontakt mailowy i obsługa programu</span>
            </div>
            <div className="pethelp-highlight mt-3">
              Na jeden adres e-mail można aktywować jeden pakiet. Dodatkowo
              można dokupić ochronę od nagłych zachorowań i nieszczęśliwych
              wypadków pupila.
            </div>
          </div>
        </div>
      </section>

      <section className="pethelp-two-column">
        <div className="pethelp-card">
          <div className="pethelp-eyebrow">Dlaczego warto</div>
          <h3 className="pethelp-title-sm">Korzyści dla opiekuna</h3>
          <ul className="pethelp-points">
            {benefits.map((benefit) => (
              <li key={benefit}>{benefit}</li>
            ))}
          </ul>
        </div>
        <br />
        <div className="pethelp-card pethelp-showcase">
          <img src="/tvp/pethelp-image2.png" alt="Dodatkowe korzyści Pethelp" />
        </div>
      </section>

      <section className="pethelp-feature-grid">
        <div className="pethelp-service-card">
          <div className="pethelp-eyebrow">Pies</div>
          <h3 className="pethelp-title-sm">Zakres dla psa</h3>
          <ul className="pethelp-points">
            {serviceHighlights.dog.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <br />
        <div className="pethelp-service-card">
          <div className="pethelp-eyebrow">Kot</div>
          <h3 className="pethelp-title-sm">Zakres dla kota</h3>
          <ul className="pethelp-points">
            {serviceHighlights.cat.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="pethelp-highlight">
        <b>12 miesięcy ochrony i profilaktyki.</b> Pakiety działają przez cały
        rok i porządkują opiekę nad pupilem w modelu bardziej przewidywalnym
        kosztowo niż pojedyncze wizyty i badania kupowane osobno.
      </section>
    </div>
  );
};

export default Ogolne;
